import React, { useEffect, useState } from "react";
import * as OFMSUI from "react-bootstrap";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HousingService from "../../../Services/HousingService";
import Swal from "sweetalert2";
import { FaFastBackward } from "react-icons/fa";

const EmployeeConfirmation = () => {
  const history = useHistory();
  const [BankDetails, setBankDetails] = useState([]);
  const [district, setDistrict] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);



  useEffect(() => {
    const params = { code: "All" };
    HousingService.EmployeeConfirmation(params).then((res) => { if (res.data) { setBankDetails(res.data); } }).catch((error) => { console.error("Error fetching Bank Name Account Number:", error); });
    HousingService.CGG_District().then((res) => { if (res.data) { setDistrict(res.data); } }).catch((error) => { });
  }, []);



  const handleCheckboxClick = (index) => { if (selectedRows.includes(index)) { setSelectedRows(selectedRows.filter((i) => i !== index)); } else { setSelectedRows([...selectedRows, index]); } };

  const showNotification = (type, message) => {
    if (type === "success") { Swal.fire("Success", message, "success"); }
    else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); }
  };


  const handleConfirm = () => {
    if (selectedRows.length > 0) { const selectedRowsData = selectedRows.map( (index) => BankDetails[index] );

      const requestBody = selectedRowsData.map((row) => ({ status: "update", emp_id: row.emp_id, code: row.security_code, designation_code: row.designation_code, }));

      Swal.fire({ text: "Are You Sure Want to Confirm?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const Update = await HousingService.UpdateEmpdetailsConfirm( requestBody );
            if (Update?.data?.SCODE === "01") {
              Swal.fire({ icon: "success", title: "Success", text: "Confirmed Successfully",
                confirmButtonText: "OK", }).then(() => { window.location.reload(); });
            } else { Swal.fire({ icon: "error", title: "Error", text: "Failed to confirm", });
            }
          } catch (error) { Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again.", }); } } });
    } else { Swal.fire({ icon: "error", title: "Error", text: "Please Select CheckBox", }); } };


  // const handleDelete = () => {
  //   if (selectedRows.length > 0) {
  //     const selectedRowsData = selectedRows.map((index) => BankDetails[index]); const requestBody = selectedRowsData.map((row) => ({ status: "delete", emp_id: row.emp_id }));
  //     Swal.fire({ text: "Are You Sure Want to Delete?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then(async (result) => {
  //       if (result.isConfirmed) { const Update = await HousingService.UpdateEmpdetailsConfirm(requestBody); if (Update?.data?.SCODE === "01") { showNotification("success", "Deleted successfully By GMF"); window.location.reload(); } }
  //     });
  //   } else {
  //     showNotification("error", "Please Select CheckBox ");
  //   }
  // };

  const handleDelete = () => {
  if (selectedRows.length > 0) { const selectedRowsData = selectedRows.map( (index) => BankDetails[index] );

    const requestBody = selectedRowsData.map((row) => ({ status: "delete", emp_id: row.emp_id, }));

    Swal.fire({ text: "Are You Sure Want to Delete?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const Update = await HousingService.UpdateEmpdetailsConfirm(
            requestBody
          );

          if (Update?.data?.SCODE === "01") { Swal.fire({ icon: "success", title: "Success", text: "Deleted Successfully By GMF", confirmButtonText: "OK", }).then(() => { window.location.reload(); });
          } 
          else { Swal.fire({ icon: "error", title: "Error", text:"Failed to delete employee details.", }); }
        } 
        
        catch (error) { Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again.", }); }
      }
    });
  } 
  
  else { Swal.fire({ icon: "error", title: "Error", text: "Please Select CheckBox", }); }
};
  return (
    <div>
      <NavigationServicesHeader />
      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}>Employee Confirmation</h1> </div> </OFMSUI.Col>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="reset" onClick={() => history.goBack()} > <FaFastBackward /> &nbsp;Back </button> </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container ">

        <OFMSUI.Table striped bordered hover id="my-table">
          <thead className="fw-bold">
            <tr> <td colSpan={7} style={{ textAlign: "center" }}> District-Wise Employee's to be confirmed </td> </tr>
            <tr className="table_countshead"> <th>S No.</th> <th style={{ width: "9%" }}> District Name</th> <th>Emp Id</th> <th style={{ width: "30%" }}>Employee Name </th> <th>Designation </th> <th> Work place/ Location </th> <th>Confirm/Delete </th> </tr>
          </thead>

          <tbody>
            {BankDetails.map((item, index) => (
              <tr key={index}> <td>{index + 1}</td> <td>{item.security_name}</td> <td>{item.emp_id}</td> <td>{item.name}</td> <td>{item.designation_name}</td> <td> {item.work_location1} <td>{item.work_location2}</td> </td> <td> <input type="checkbox" onClick={() => { handleCheckboxClick(index); }} /> </td>
              </tr>
            ))}
          </tbody>
        </OFMSUI.Table>
        <div style={{ textAlign: "center" }}>
          <button className="btn btn-success btn-sm" onClick={handleConfirm}>
            Confirm
          </button>

          <button className="btn btn-danger btn-sm" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </OFMSUI.Container>
    </div>
  );
};

export default EmployeeConfirmation;
